import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/ui/Modal.vue";
  import { reactive, watch } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { email, helpers, required } from "@vuelidate/validators";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import Cleave from "vue-cleave-component";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { validPhoneNumber } from "@/helpers/validation";
  import { eventTracking } from "@/helpers/googleAnalyticsEventTracking";
  import {
    EventActionName,
    EventByAction,
    EventByCategory,
    EventLabelByName,
  } from "@/types/EventTracking";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactUsModal',
  props: {
    isOpen: {
      type: Boolean,
      required: false,
    },
    lot: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  emits: ["send"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const props = __props;

  const formFields = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    message: "",
  };

  let form = reactive(Object.assign({}, formFields));

  const rules = {
    firstName: { required },
    lastName: { required },
    phone: {
      required,
      validPhoneNumber: helpers.withMessage(
        "Value must be valid phone number",
        validPhoneNumber
      ),
    },
    email: { required, email },
  };

  watch(
    () => props.isOpen,
    (value) => {
      if (value) {
        onClose();
      }
    }
  );

  const v$ = useVuelidate(rules, form);

  function onClose() {
    clearForm();
    resetVuelidateErrors(v$);
  }

  async function submitForm() {
    v$.value.$touch();
    const isValid = await v$.value.$validate();

    if (!isValid) {
      return;
    }

    const { email, ...rest } = form;
    const data = {
      email: email.toLowerCase(),
      ...rest,
    };

    if (props.lot) {
      data.lotTitle = props.lot.lotId.title;
    }

    convertToLead();
    emits("send", data);
  }

  function clearForm() {
    Object.assign(form, formFields);
  }

  const convertToLead = () => {
    const { lot } = props;
    const eventLabelByName = lot
      ? EventLabelByName.CONTACT_US
      : EventLabelByName.MAKE_ENQUIRY;

    const estateById = lot?.estateId || "Not estate selected";

    eventTracking({
      actionsName: EventActionName.CONVERT_TO_LEAD,
      eventByCategory: EventByCategory.LEAD_CONVERSION,
      eventLabelByName,
      eventByAction: EventByAction.CLICK,
      estateById,
    });
  };

const __returned__ = { emits, props, formFields, get form() { return form }, set form(v) { form = v }, rules, v$, onClose, submitForm, clearForm, convertToLead, Modal, reactive, watch, get useVuelidate() { return useVuelidate }, get email() { return email }, get helpers() { return helpers }, get required() { return required }, get resetVuelidateErrors() { return resetVuelidateErrors }, get Cleave() { return Cleave }, get phoneNumberOption() { return phoneNumberOption }, get validPhoneNumber() { return validPhoneNumber }, get eventTracking() { return eventTracking }, get EventActionName() { return EventActionName }, get EventByAction() { return EventByAction }, get EventByCategory() { return EventByCategory }, get EventLabelByName() { return EventLabelByName } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})